// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VRcC","fullView":"styles_fullView__2PwvZ"};